import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getBrowserProduct } from '@/helpers';
import { GroupOrderPageLoadEvent } from '@/services/analytics/events';

enum CopyButtonText {
  Copy = 'COPY',
  Copied = 'COPIED!',
}

@Component({
  name: 'CmgBagGroupOrderDetails',
})
export default class CmgBagGroupOrderDetails extends Vue {
  copyButtonText = CopyButtonText.Copy;

  get groupOrderUrl(): string {
    const order = this.$appStore.state.order.pendingGroupOrder;
    return order ? `${window.location.protocol}//${window.location.host}/grouporder/${order.order.groupOrderId}` : '';
  }

  onCopyClick() {
    const el = this.$refs.urlText as HTMLInputElement;

    if (getBrowserProduct(navigator) === 'MobileSafari') {
      el.readOnly = false;
      const range = document.createRange();
      range.selectNodeContents(el);
      const selection = window.getSelection();
      if (!selection) {
        return; // this should be unreachable
      }
      selection.removeAllRanges();
      selection.addRange(range);
      el.setSelectionRange(0, 1000);
      el.readOnly = true;
    } else {
      el.select();
    }

    document.execCommand('copy');
    this.copyButtonText = CopyButtonText.Copied;
    setTimeout(() => (this.copyButtonText = CopyButtonText.Copy), 2000);
  }

  onClickCancel(event: any) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('cancelGroupOrder', true);
    this.$nextTick(() => this.$services.ui.focusDiv('.cmg-modal-container'));
    this.$services.analytics.send(new GroupOrderPageLoadEvent('cancel'));
  }
}
